"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellPopoverFooter = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
function CellPopoverFooter(_a) {
    var onClick = _a.onClick, _b = _a.submitButtonType, submitButtonType = _b === void 0 ? 'submit' : _b, _c = _a.submitButtonText, submitButtonText = _c === void 0 ? 'Save' : _c, _d = _a.loading, loading = _d === void 0 ? false : _d;
    return (react_1.default.createElement(core_ui_1.Box, { borderTop: 1 },
        react_1.default.createElement(core_ui_1.Flexbox, { justifyContent: "flex-end", flex: 1, width: "100%" },
            react_1.default.createElement(core_ui_1.Padding, { x: 24, y: 12 },
                react_1.default.createElement(core_ui_1.Button, { type: submitButtonType, onClick: onClick, loading: loading }, submitButtonText)))));
}
exports.CellPopoverFooter = CellPopoverFooter;
